import { Component, OnInit, ViewEncapsulation, Inject, ElementRef } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-dialogo-valores-declaracion-sugerida',
  templateUrl: './dialogo-val-decla-sugerida.component.html',
  styleUrls: ['./dialogo-val-decla-sugerida.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DialogoValoresDeclaracionSugeridaComponent implements OnInit {

  constructor(
  	public dialogRef: MatDialogRef<DialogoValoresDeclaracionSugeridaComponent>, 
    @Inject(MAT_DIALOG_DATA) private declaracionSugerida: any,
    private elRef: ElementRef
  ) { }

  ngOnInit() {
    //this.elRef.nativeElement.scrollTop = this.elRef.nativeElement.scrollHeight;
  }

  ngAfterViewChecked() {
    //this.elRef.nativeElement.scrollTop = this.elRef.nativeElement.scrollHeight; 
  }

}



// WEBPACK FOOTER //
// D:/GIT/F300/V4/ng_formulario300v4/src/app/components/declaracion-sugerida/dialogo-valores-declaracion-sugerida/dialogo-valores-declaracion-sugerida.component.ts